import { render, staticRenderFns } from "./shopqr.vue?vue&type=template&id=1b871471&scoped=true&"
import script from "./shopqr.vue?vue&type=script&lang=js&"
export * from "./shopqr.vue?vue&type=script&lang=js&"
import style0 from "./shopqr.vue?vue&type=style&index=0&id=1b871471&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b871471",
  null
  
)

export default component.exports